export default function TeamInfo({ img, name }) {
  return (
    <div className="team-content">
      <div className="team-info">
        <img src={img || '/assets/default.png'} alt={name} className="team-logo" loading="lazy" />
        <span className="team-name">{name}</span>
      </div>
    </div>
  );
}